module.exports = __webpack_public_path__ + "48c72391d15c7db874434048151a9b2b.svg";